export default "__VITE_ASSET__BYp6Zkeo__"